import { FormControl } from "@angular/forms";
import { digitsFaToEn, phoneNumberValidator } from '@persian-tools/persian-tools';

export function iranPhoneValidator (controller: FormControl) {
    let value = digitsFaToEn(`${controller.value}`);
    const validate = !!phoneNumberValidator(value);

    return validate ? null : {
        pattern: {
            valid: false
        }
    };
}
